(function () {
    "use strict";

    // @ngInject
    function WorkspaceFeedSwitchControllerCtor($scope, $injector, $stateParams, StatsigService, UsersManager, FeedService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkspaceFeedSwitchController';

        const currUser = UsersManager.getCurrUser();
        const isVendor = currUser.isVendor();
        const isClient = currUser.isClient();
        const isVendorAsClient = isVendor &&
            currUser.workspace_user_data &&
            currUser.workspace_user_data.workspace_role === 'host';

        this.version = null;
        if (isClient || isVendorAsClient) {
            this.version = 'angular';
        } else {
            this.version ='react';
        }

        // Pass testExecutionId from Angular route to React component
        this.testExecutionId = $stateParams.testExecutionId;

        this.onSharePvlClick = function(pvl) {
            FeedService.feedEditorInstance.callOnSharePreferredVendors(pvl);
        };
    }

    Controllers.WorkspaceFeedSwitchController = Class(Controllers.BaseController, {
        constructor: WorkspaceFeedSwitchControllerCtor,
    });
}());
